import React, { useCallback, useEffect, useRef, useState } from "react";
import { Checkbox, Empty, Input, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { addUpdateCheckpoint } from "../../../../store/chats/thunks";
import { scrollToBottom } from "../../../../utils/uiElementScroll";
import CustomCollapse from "../../../../components/generic/CustomDetails";
import Modal from "../../../../components/generic/Modal";
import { useChecklists } from "../../../../hooks/useChecklists";

const CheckList = () => {
  const [submitting, setSubmitting] = useState(false);
  const [checkPoint, setCheckPoint] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);

  const checklistBodyRef = useRef(null);

  const dispatch = useDispatch();

  const { checklists, loading, selectedTenantId, selectedChatId } =
    useChecklists();

  const onAddCheckPoint = useCallback(
    async (item) => {
      try {
        setSubmitting(true);

        const id = item?.id;

        const title = id ? item?.target?.value || item?.title || "" : checkPoint;

        const payload = {
          conversation_id: selectedChatId,
          tenant_id: selectedTenantId,
          title,
          is_checked: id ? !item.is_checked : false,
          ...(id && { id }),
        };

        await dispatch(addUpdateCheckpoint(payload));

        setCheckPoint("");
        setShowAddModal(false);
        scrollToBottom(checklistBodyRef);
      } catch (error) {
        console.error("Failed to add/update checkpoint:", error);
      } finally {
        setSubmitting(false);
      }
    },
    [selectedChatId, selectedTenantId, checkPoint, dispatch],
  );

  useEffect(() => {
    if (selectedChatId && !loading) scrollToBottom(checklistBodyRef);
  }, [loading, selectedChatId]);

  return (
    <>
      <div className="flex-col checklist-body">
      <CustomCollapse
        className="custom-collapse productivity-padding checklist-collapse "
        title="Checklist"
        //@ts-ignore
        headerRight={
          <span
            onClick={(e) => {
              e.preventDefault();
              setShowAddModal(true);
            }}
          >
            <PlusOutlined />
          </span>
        }
        open
      >
        <div className="checklist-content" ref={checklistBodyRef}>
          {loading ? (
            <div
              className="flex justify-center h-100 w-100 align-center"
              style={{
                marginTop: "10px",
              }}
            >
              <Spin />
            </div>
          ) : checklists?.length ? (
            checklists.map((point, i) => (
              <div key={i} className="checklist-item">
                <Checkbox
                  defaultChecked={point.is_checked}
                  onChange={() => onAddCheckPoint(point)}
                >
                  <div className="ellipsis-text check-point">{point.title}</div>
                </Checkbox>
              </div>
            ))
          ) : (
            <div className="flex justify-center h-100 w-100 align-center">
              <Empty
                description="No Checklist Found"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </div>
          )}
        </div>
      </CustomCollapse> 
      <div className="checklist-footer">
          <Input
            placeholder="Enter your check point..."
            value={checkPoint}
            style={{ resize: "none" }}
            disabled={submitting}
            onChange={(e) => setCheckPoint(e.target.value)}
            onPressEnter={(e) => {
              if (!e.shiftKey) {
                e.preventDefault();
                onAddCheckPoint(e);
              }
            }}
          />
        </div>
      </div>
      <Modal
        isProcessing={submitting}
        title="Add New Check Point"
        onCancel={() => setShowAddModal(false)}
        width={500}
        open={showAddModal}
        onOk={onAddCheckPoint}
      >
        <Input
          placeholder="Enter your check point..."
          value={checkPoint}
          style={{ resize: "none" }}
          disabled={submitting}
          onChange={(e) => setCheckPoint(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default CheckList;
